import { render, staticRenderFns } from "./FrontalDeExpediente.vue?vue&type=template&id=1ae731e0&scoped=true&"
import script from "./FrontalDeExpediente.vue?vue&type=script&lang=js&"
export * from "./FrontalDeExpediente.vue?vue&type=script&lang=js&"
import style0 from "./FrontalDeExpediente.vue?vue&type=style&index=0&id=1ae731e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae731e0",
  null
  
)

export default component.exports